import L from "leaflet";

const US_CENTER = [39.8283, -98.5795];
const US_ZOOM = 5;

function initFuelCardMap() {
  const mapContainer = document.querySelector("#fuel-card-map");
  if (!mapContainer) return;

  const map = L.map("fuel-card-map", {
    zoomControl: true,
    scrollWheelZoom: false,
  });

  L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
  }).addTo(map);

  map.setView(US_CENTER, US_ZOOM);

  fetch("/services/fuel-card/locations.json")
    .then((response) => {
      if (!response.ok) {
        console.log("Failed to fetch locations");
      }
      return response.json();
    })
    .then((data) => {
      const locations = data.locations || [];
      
      locations.forEach((location) => {
        const { latitude, longitude, color } = location;
        
        if (latitude && longitude) {
          const marker = L.circleMarker([latitude, longitude], {
            color: color.border,
            fillColor: color.bg,
            fillOpacity: 0.7,
            radius: 4,
            weight: 1,
          });

          marker.addTo(map);
        }
      });

      if (locations.length > 0) {
        const bounds = locations
          .filter((loc) => loc.latitude && loc.longitude)
          .map((loc) => [loc.latitude, loc.longitude]);
        
        if (bounds.length > 0) {
          const group = new L.featureGroup(
            bounds.map((coord) => L.marker(coord))
          );
          const boundsObj = group.getBounds();
          const boundsZoom = map.getBoundsZoom(boundsObj);
          
          if (boundsZoom >= US_ZOOM) {
            map.fitBounds(boundsObj.pad(0.1), {
              maxZoom: 19,
            });
          }
        }
      }
    })
    .catch((error) => {
      console.error("Error loading fuel card locations:", error);
    });
}

document.addEventListener("turbo:load", () => {
  initFuelCardMap();
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFuelCardMap);
} else {
  initFuelCardMap();
}

